<div>
  <div class="pure-menu pure-menu-horizontal">
    <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">Change Transit Time Configuration</a>
  </div>
  <div class="container">

    <!-- Select option for From Country Code Options -->
    <form [formGroup]="configureTransitTimeForm" class="pure-form pure-form-stacked" (ngSubmit)="render()">
      <!-- Select option for From Country Code Options -->
      <div class="pure-control-group">
        <label for="fromCountryCodeId">From Country Code <app-popover [message]="help_messages.from_country_code"></app-popover></label>
        <select id="fromCountryCodeId" class="pure-input-2-3"
                formControlName="fromCountryCode" (change)="onFromCountryCodeChange(fromCountryCodeRef.value)" #fromCountryCodeRef>
          <option *ngFor="let _fromCountryCode of fromCountryCodeOptions; let i = index"
                  [value]="_fromCountryCode">
            {{ _fromCountryCode }}
          </option>
        </select>
      </div>

      <div class="pure-control-group">
        <label for="businessUseCase">Business Use Case  <app-popover [message]="help_messages.business_unit"></app-popover></label>
        <select name="businessUseCase" id="businessUseCase" class="pure-input-2-3" formControlName="businessUseCase" #businessUseCaseRef (change)="onBusinessUseCaseChange(businessUseCaseRef.value)">
          <ng-template ngFor let-item [ngForOf]="getItems">
            <optgroup label="{{item.name}}">
              <option *ngFor="let usecase of item.usecases" [value]="usecase.value">
                {{usecase.text}}
              </option>
            </optgroup>
          </ng-template>
        </select>
      </div>

      <!-- Submit Button -->
      <div>
        <button class="pure-button pure-button-primary button-large" type="submit"
                [disabled]="configureTransitTimeForm.invalid">
          Submit
        </button>
      </div>
    </form>

    <!-- Table to display transit time configurations -->
    <div *ngIf="transitTimeConfigurations.length != 0 && !loading">
      <table class="pure-table pure-table-horizontal">
        <thead>
        <tr>
          <th>Business Use Case</th>
          <th>From Country Code</th>
          <th>Level Of Data</th>
          <th>Transit Time Type</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let _row of transitTimeConfigurations">
          <td>
            {{_row.businessUseCase}}
          </td>
          <td>
            {{_row.fromCountryCode}}
          </td>
          <td>
            {{_row.componentKeyValue}}
          </td>
          <td *ngIf="!isPassportEnabledShipmethod(_row)">
            <div class="pure-button-group" role="group" aria-label="...">
              <button class="pure-button button-small"
                      [ngClass]="{'pure-button-primary disabled': _row.transitTimeType == carrier_provided}"
                      (click)="changeTransitTimeType(_row, carrier_provided)">
                Carrier Provided
              </button>
              <button class="pure-button button-small"
                      [ngClass]="{'pure-button-primary disabled': _row.transitTimeType == computed}"
                      (click)="changeTransitTimeType(_row, computed)"> Computed
              </button>
              <button class="pure-button button-small"
                      [ngClass]="{'pure-button-primary disabled': _row.transitTimeType == ml_optimized}"
                      (click)="changeTransitTimeType(_row, ml_optimized)"> ML Optimized
              </button>
              <button class="pure-button button-small"
                      [ngClass]="{'pure-button-primary disabled': _row.transitTimeType == precision_optimized}"
                      (click)="changeTransitTimeType(_row, precision_optimized)"> Precision Optimized
              </button>
              <button class="pure-button button-small"
                      [ngClass]="{'pure-button-primary disabled': _row.transitTimeType == HYBRID_TRANSIT_TIME_TYPE}"
                      (click)="changeTransitTimeType(_row, HYBRID_TRANSIT_TIME_TYPE)"> Hybrid Transit Time
              </button>
            </div>
          </td>
          <td *ngIf="isPassportEnabledShipmethod(_row)">
            This ship method is migrated to passport
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Display message when the table is empty -->
    <div *ngIf="transitTimeConfigurations.length == 0 && !loading && !firstLoad">
      <h2>There are no on boarded transit time units.</h2>
    </div>

    <app-loader [loading]="loading" [size]="'small'"></app-loader>
  </div>

</div>
